var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ruc-validations", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
            _c("h1", { staticClass: "text-xs-center" }, [
              _vm._v("Comencemos con la afiliación")
            ])
          ]),
          _c(
            "v-layout",
            {
              staticClass: "my-4",
              attrs: {
                "align-center": "",
                "justify-center": "",
                column: "",
                "fill-height": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { md5: "", sm12: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.desktop,
                          expression: "desktop"
                        }
                      ]
                    },
                    [
                      _c("h2", { staticClass: "text-md-center" }, [
                        _vm._v("Ingresa RUC o RUS para validarlo")
                      ])
                    ]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { md8: "", "offset-md2": "", sm12: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "style-stepped my-21px",
                        class: { ruc__disabled: _vm.loading },
                        attrs: {
                          label: "Nº de RUC / RUS",
                          type: "text",
                          name: "ruc",
                          disabled: _vm.loading,
                          error: _vm.$v.ruc.$error,
                          "error-messages": _vm.rucErrorMessage,
                          maxlength: "11",
                          readonly: _vm.isValidate
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.ruc.$touch()
                          },
                          keypress: _vm.onlyNumbers
                        },
                        model: {
                          value: _vm.ruc,
                          callback: function($$v) {
                            _vm.ruc = $$v
                          },
                          expression: "ruc"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-layout",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.desktop,
                          expression: "desktop"
                        }
                      ],
                      staticClass: "ruc__requirements",
                      attrs: { row: "", "justify-center": "" }
                    },
                    [
                      _c("v-flex", { attrs: { md9: "" } }, [
                        _c("p", [
                          _vm._v(
                            "Para continuar el cliente debe de contar con :"
                          )
                        ]),
                        _c("ul", [
                          _c("li", [_vm._v("Datos del Representante Legal")]),
                          _c("li", [_vm._v("Datos del Negocio")]),
                          _c("li", [
                            _vm._v(
                              "Datos de cuenta bancaria (a nombre de la Razón Social) "
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticClass: "data__response" }, [
                    _vm.invalidMessage
                      ? _c("div", { staticClass: "text-valid" }, [
                          _c("p", { staticClass: "mb-3" }, [
                            _vm._v(_vm._s(_vm.invalidMessage))
                          ])
                        ])
                      : _vm._e(),
                    _vm.isSuccess
                      ? _c(
                          "div",
                          { staticClass: "text-valid" },
                          [
                            _c("p", [_vm._v("Tu RUC ha sido validado")]),
                            _c("h4", { staticClass: "font-bariol" }, [
                              _vm._v(_vm._s(_vm.businessName))
                            ]),
                            _c("p", [
                              _vm._v("Ahora necesitamos los "),
                              _c("br"),
                              _vm._v(" datos de tu negocio")
                            ]),
                            _vm.isVisanetClient
                              ? _c(
                                  "p",
                                  { staticClass: "message-visanet-cliente" },
                                  [
                                    _vm._v(
                                      "Este comercio ya es cliente de Niubiz. Se mantienen las comisiones regulares."
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  { staticClass: "message-visanet-cliente" },
                                  [
                                    _vm._v(
                                      "Este es un comercio nuevo, aplica a comisión unificada. "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " No se consideran los giros con comisiones especiales ni escalonadas."
                                    )
                                  ]
                                ),
                            _c(
                              "v-dialog",
                              {
                                attrs: { width: "600px" },
                                model: {
                                  value: _vm.dialog,
                                  callback: function($$v) {
                                    _vm.dialog = $$v
                                  },
                                  expression: "dialog"
                                }
                              },
                              [
                                _c(
                                  "v-card",
                                  { staticStyle: { "padding-bottom": "3rem" } },
                                  [
                                    _c(
                                      "v-card-actions",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "flex-end"
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: _vm.tableComissionClose
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("close ")])],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "h3",
                                      {
                                        staticStyle: {
                                          "text-align": "center",
                                          "margin-top": "-10px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Conoce las comisiones (Opcional)"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-layout",
                                      [
                                        _c("v-flex", { attrs: { xs2: "" } }),
                                        _c(
                                          "v-flex",
                                          {
                                            staticStyle: {
                                              position: "relative"
                                            },
                                            attrs: { xs1: "" }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  position: "absolute",
                                                  top: "60%",
                                                  left: "40%",
                                                  transform:
                                                    "translate(-50%, -50%)"
                                                }
                                              },
                                              [_vm._v("Giro ")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px"
                                            },
                                            attrs: { xs9: "" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "70%",
                                                  display: "block",
                                                  "font-size": "10px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-autocomplete",
                                                  {
                                                    staticStyle: {
                                                      background: "transparent",
                                                      "max-width": "315px",
                                                      heigth: "auto",
                                                      "line-height": "24px",
                                                      "text-align": "left",
                                                      "font-size":
                                                        "10px !important"
                                                    },
                                                    attrs: {
                                                      items:
                                                        _vm.opCommercialBusiness,
                                                      "item-text":
                                                        "Description",
                                                      "item-value": "Code",
                                                      "component-item":
                                                        _vm.template
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.listenerAutocomplete
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "option",
                                                        fn: function(option) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "option__select"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "option__description"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        option.Description
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          slot: "no-options"
                                                        },
                                                        slot: "no-options"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Sorry, no matching options."
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-layout",
                                      {
                                        staticStyle: { margin: "10px 0px" },
                                        attrs: {
                                          "align-center": "",
                                          "justify-center": "",
                                          column: "",
                                          "fill-height": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "primary-button afilliation__btn",
                                            on: {
                                              click: function($event) {
                                                _vm.consultMcci(_vm.codeMcci)
                                              }
                                            }
                                          },
                                          [_c("span", [_vm._v("Validar")])]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-layout",
                                      {
                                        staticStyle: { margin: "0px 10px" },
                                        attrs: {
                                          "align-center": "",
                                          "justify-center": "",
                                          column: "",
                                          "fill-height": ""
                                        }
                                      },
                                      [
                                        _vm.isSelectGiro
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "font-weight": "bolder"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "(*)Debe ingresar el giro"
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.tableComision
                                          ? _c("comisions")
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "align-center": "",
                                          "justify-center": ""
                                        }
                                      },
                                      [
                                        _vm.tableComision
                                          ? _c(
                                              "span",
                                              { staticClass: "descComision" },
                                              [
                                                _vm._v(
                                                  "*La comisión es un cobro del servicio que se descuenta del monto total de la  venta.\n*La comisión foránea aplica a las ventas realizadas con tarjetas emitidas en el extranjero.\n*La comisión flat es el cobro de un monto fijo por cada venta.\n*Si hay una campaña activa se aplicarán las tarifas que esta ofrece."
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-layout",
            {
              attrs: {
                "align-center": "",
                "justify-center": "",
                column: "",
                "fill-height": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button afilliation__btn",
                  class: { hidden__btn: _vm.invalidMessage },
                  attrs: {
                    disabled: _vm.loading || _vm.$v.$invalid,
                    type: "submit"
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.isSuccess ? "continuar" : "validar"))
                  ])
                ]
              )
            ],
            1
          ),
          _vm.isValidate || _vm.invalidMessage
            ? _c(
                "v-layout",
                { attrs: { "align-center": "", "justify-center": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button text black",
                      attrs: { small: "" },
                      on: { click: _vm.findAgain }
                    },
                    [_vm._v("Volver a Validar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c("loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "loaderModal",
            attrs: { text: "Realizando validación" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18cb4eaf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18cb4eaf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/ruc-validations.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-18cb4eaf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/ruc-validations.vue
// module chunks = 0 1 2 3